"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecommendationStatus = void 0;
var _recommendationSelectors = require("../../store/recommendation/recommendationSelectors");
var _questionnaireSelectors = require("../../store/questionnaire/questionnaireSelectors");
var _lodash = _interopRequireDefault(require("lodash.isempty"));
var _useAppSelector = require("../useAppSelector");
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useRecommendationStatus = () => {
  var _metadata$flags;
  const recommendationRawData = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectRecommendationRawData);
  const recommendationHandsets = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectRecommendationHandsets);
  const recommendationPlans = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectRecommendationPlans);
  const recommendationBroadbands = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectRecommendationBroadbands);
  const recommendationBusinessSolutions = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectRecommendationBusinessSolutions);
  const metadata = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectMetadata);
  if (!(metadata !== null && metadata !== void 0 && metadata.flags)) return {};
  const {
    phone: phoneFlag,
    plan: planFlag,
    broadband: broadbandFlag,
    businessSolution: businessSolutionFlag
  } = metadata === null || metadata === void 0 ? void 0 : metadata.flags;
  const areHandsetsPresent = recommendationHandsets.length > 0;
  const arePlansPresent = recommendationPlans.length > 0;
  const areBroadbandsPresent = recommendationBroadbands.length > 0;
  const areBusinessSolutionsPresent = recommendationBusinessSolutions.length > 0;
  const isRecommendationFetched = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectIsRecommendationFetched);
  const isRecommendationEmpty = (0, _lodash.default)(recommendationRawData);
  const isRecommendationReady = areHandsetsPresent || arePlansPresent || areBroadbandsPresent || areBusinessSolutionsPresent;
  const isJourneyForHandsetAndPlan = (areHandsetsPresent || phoneFlag) && (arePlansPresent || planFlag) || (metadata === null || metadata === void 0 ? void 0 : (_metadata$flags = metadata.flags) === null || _metadata$flags === void 0 ? void 0 : _metadata$flags[_constants.FLAGS.BOTH_FLOW]);
  const isJourneyForHandset = areHandsetsPresent || phoneFlag;
  const isJourneyForPlan = arePlansPresent || planFlag;
  const isJourneyForBroadband = areBroadbandsPresent || broadbandFlag;
  const isJourneyForBusinessSolution = areBusinessSolutionsPresent || businessSolutionFlag;
  const isJourneyForObject = {
    isJourneyForHandset,
    isJourneyForHandsetAndPlan,
    isJourneyForPlan,
    isJourneyForBroadband,
    isJourneyForBusinessSolution
  };
  return {
    isJourneyForHandsetAndPlan,
    isJourneyForHandset,
    isJourneyForPlan,
    isJourneyForBroadband,
    isJourneyForBusinessSolution,
    areHandsetsPresent,
    arePlansPresent,
    areBroadbandsPresent,
    areBusinessSolutionsPresent,
    isRecommendationFetched,
    isRecommendationReady,
    isJourneyForObject,
    isRecommendationEmpty
  };
};
exports.useRecommendationStatus = useRecommendationStatus;